import { Translate } from 'react-localize-redux';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IconVariants } from '../foundations/Icon';
import { Button, Label } from '../widgets';
import css from './SubPageHeader.css';

export const GO_BACK_BUTTON_TEXT = 'STATIC.BUTTONS.GO_BACK';

const SubPageHeader = ({
    onGoBack,
    goBackTranslationKey = GO_BACK_BUTTON_TEXT,
    labelTranslationKey,
    labelTextReplace = {},
    className = '',
    rightSection,
}) => {
    return (
        <div className={classNames(css.header, className)}>
            <div className={css.mainContent}>
                <Button
                    onClick={onGoBack}
                    type="link"
                    Icon="chevron-left"
                    iconVariant={IconVariants.LIGHT}
                    className={css.backButton}
                >
                    <Translate id={goBackTranslationKey} />
                </Button>
                <Label text={labelTranslationKey} textReplace={labelTextReplace} className={css.title} />
            </div>
            {rightSection}
        </div>
    );
};

SubPageHeader.propTypes = {
    onGoBack: PropTypes.func.isRequired,
    labelTranslationKey: PropTypes.string.isRequired,
    labelTextReplace: PropTypes.object,
    goBackTranslationKey: PropTypes.string,
    className: PropTypes.string,
    rightSection: PropTypes.node,
};

export default SubPageHeader;
